'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dCode$0024 from "./presto.types$-User-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_UsersView$$anon$39(outer) {
  this.bOb = null;
  this.bO9 = null;
  this.bOa = false;
  this.bO7 = null;
  this.bO8 = false;
  this.bOc = false;
  this.bOd = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bOb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_UsersView$$anon$39 as $c_Lpresto_UsersView$$anon$39 };
$p = $c_Lpresto_UsersView$$anon$39.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UsersView$$anon$39;
/** @constructor */
function $h_Lpresto_UsersView$$anon$39() {
}
export { $h_Lpresto_UsersView$$anon$39 as $h_Lpresto_UsersView$$anon$39 };
$h_Lpresto_UsersView$$anon$39.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bOb;
});
$p.t = (function() {
  if ((!this.bOa)) {
    this.bO9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bOa = true;
  }
  return this.bO9;
});
$p.ae = (function() {
  if ((!this.bO8)) {
    this.bO7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dCode$0024.$m_Lpresto_types$UserCode$().a2I(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bO8 = true;
  }
  return this.bO7;
});
$p.w = (function() {
  if ((!this.bOd)) {
    this.bOc = false;
    this.bOd = true;
  }
  return this.bOc;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_UsersView$$anon$39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UsersView$$anon$39, "presto.UsersView$$anon$39", ({
  UQ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_UsersView$$anon$39 as $d_Lpresto_UsersView$$anon$39 };
//# sourceMappingURL=presto.-Users-View$$anon$39.js.map
